import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {sortBy, filter, map, first} from 'lodash';
import styles from '../Catalog.scss';
import stylesMobile from '../CatalogMobile.scss';
import {isDesktop} from 'src/logic/utils';
import cx from 'classnames';
import carImg from 'src/imgs/car/default-car.jpg';
import Media from 'react-responsive';
import SortLabel from 'src/components/SortLabel/SortLabel';
import {Link} from 'react-router';
import {getIdByURL} from 'src/logic/utils';

const baseApiUrl = process.env.BASE_API;

const neededStyles= {
  car_container: isDesktop()?styles.car_container:stylesMobile.mobile_car_container,
  responsive_img: isDesktop()?styles.responsive_img:stylesMobile.mobile_responsive_img
};

export default class ProductTable extends Component {
  constructor(props, context) {
    super(props, context);
    props.getModels(getIdByURL());
  }

  render() {
    // var showCarInMobile = false;
    const brand = this.props.brand;
    const brandCatalog = sortBy(this.props.modelList, ['modelName', 'modelYearStart']);
    const mobileBrandCatalog = (generationName) => filter(brandCatalog, function(item) {
      return item.generationName === generationName;
  });


  const items = (catalog) => map(catalog, (item, i, itemList) => {
    let title = item.generationName.length>40?(item.generationName.slice(0,30)+'...'):item.generationName;
    const modelName = itemList[i-1] && itemList[i-1].modelName === itemList[i].modelName
      ? '' : item.modelName;

    const href = `/modifications/${brand.brandId}/${item.modelId}`;

    return (
      <div className={neededStyles.car_container}>
        <strong className={styles.modelName}>{modelName || undefined}</strong>
        <Link
          to={href}
          className="link"
        >
          <img className={neededStyles.responsive_img} src={item.imgUrl} onError={(e)=> e.target.src = carImg}/>
        </Link>
        <span>
          <Link
            to={href}
            className="link"
          >
            {brand.brandName + ' ' + title}
          </Link>
        </span>
        <span className={styles.release_date}>{item.modelYearStart+' - '}{item.modelYearEnd?(item.modelYearEnd):'наст. время'}</span>
      </div>
    );
  });

  const mobileItems = () => map(brandCatalog, (item, i) => {
      return (
          <div className={stylesMobile.drop_down_category}>
            <strong>{item.generationName}</strong>
            <SortLabel className={stylesMobile.right_float}></SortLabel>
            <div className={styles.flex_table_container} style={{justifyContent: 'space-between'}}>
              {items(mobileBrandCatalog(item.generationName))}
            </div>
          </div>
      );
    });

    return (
      <div className={styles.flex_table_container}>
        <Media query="(max-width: 1024px)" style={{width:'100%'}}>
          <h2 style={{width: '100%', margin: '1rem'}}>Модель</h2>
          { mobileItems() }
        </Media>
          { isDesktop()?items(brandCatalog):''}
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/Catalog/elements/ProductTable.jsx
 **/